module.exports = __webpack_public_path__ + "static/media/salon.f8400f5f.jpg";